import { render, staticRenderFns } from "./PickupLocation.vue?vue&type=template&id=00802eab&"
import script from "./PickupLocation.vue?vue&type=script&lang=js&"
export * from "./PickupLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00802eab')) {
      api.createRecord('00802eab', component.options)
    } else {
      api.reload('00802eab', component.options)
    }
    module.hot.accept("./PickupLocation.vue?vue&type=template&id=00802eab&", function () {
      api.rerender('00802eab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/PickupLocation.vue"
export default component.exports